<template>
<div>
    <div class="nav-sale">
        <div class="con-sal">
            <span>
                <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="home">{{ $t('home') }}</a>
            </span>
             <span>{{ $t('aggiungi_modifica_piatti') }}</span>
        </div>
    </div>
    <div class="modal-backdrop fade show" v-if="showAggiunte || showSenza || showErrorModal" @click="closeModals"></div>
    <div class="modal fade show" id="aggiunte" tabindex="-1" role="dialog" v-if="showAggiunte" style="display: block;" aria-labelledby="aggiunte" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ $t('modifiche_piatto') }}</h5>
        <button type="button" class="close" @click="showAggiunte = false" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      <div class="aggiunte" >
        <span>{{ $t('aggiunte_possibili') }}</span>
        <div class="input-mod" v-for="prodotto in getSortedItems(prodotti)" :key="prodotto.code || prodotto.descrizio">
            <input style="margin-right:5px;" type="checkbox"  :name="prodotto.code" :checked="isAddChecked(prodotto)" @change="toggleAdd(prodotto)">
            <label :for="prodotto.code">{{prodotto.descrizio || prodotto.nome}}</label>
        </div>
    </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="showAggiunte = false">Close</button>
      </div>
    </div>
  </div>
</div>
    <div class="modal fade show" id="senza" tabindex="-1" role="dialog" v-if="showSenza" style="display: block;" aria-labelledby="senza" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ $t('modifiche_piatto') }}</h5>
        <button type="button" class="close" @click="showSenza = false" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
    <div class="modifiche" >
        <span>{{ $t('possono_togliere') }}</span>
        <div class="input-mod" v-for="prodotto in getSortedItems(prodotti)" :key="prodotto.descrizio || prodotto.nome">
            <input style="margin-right:5px;" type="checkbox" :name="prodotto.descrizio" v-model="minus" :value="prodotto.descrizio">
            <label :for="prodotto.descrizio">{{prodotto.descrizio || prodotto.nome}}</label>
        </div>
    </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="showSenza = false">Close</button>
      </div>
    </div>
  </div>
</div>
    <div class="modal fade show" id="errorModal" tabindex="-1" role="dialog" v-if="showErrorModal" style="display: block;" aria-labelledby="errorModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="errorModalLabel">Attenzione</h5>
        <button type="button" class="close text-white" @click="showErrorModal = false" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p style="font-size: 1.05rem; margin: 0; font-weight: 500;">{{ errorModalMessage }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="showErrorModal = false">Chiudi</button>
      </div>
    </div>
  </div>
</div>
<div class="contMenu">
    <div class="main-content-layout">
        <div class="edit-menu">
            <div class="table-card">
                <div class="table-wrapper">
                    <table class="table">
                        <thead class="thead-dark">
                            <tr>
                                <th>{{ $t('nome') }}</th>
                                <th>{{ $t('prezzo') }}</th>
                                <th>{{ $t('portata') }}</th>
                                <th>{{ $t('aggiunte') }}</th>
                                <th>{{ $t('senza') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="piatto in piatti" :key="piatto.id || piatto._id || (piatto.nome + '-' + piatto.portata)">
                                <td class="clickable-cell" @click="update(piatto)">{{piatto.nome}}</td>
                                <td>{{piatto.prezzo}}€</td>
                                <td><span class="badge-portata">{{piatto.portata}}</span></td>
                                <td>
                                    <small v-for="variante in getSortedItems(piatto.addProd)" :key="variante.prodottoId || (typeof variante === 'object' ? JSON.stringify(variante) : variante)">{{getItemLabel(variante)}}, </small>
                                </td>
                                <td>
                                    <small v-for="variante in getSortedItems(piatto.removeProd)" :key="variante.prodottoId || (typeof variante === 'object' ? JSON.stringify(variante) : variante)">{{getItemLabel(variante)}}, </small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
        <div class="edit-form-card">
            <h3 class="form-title">{{ $t('dettagli_piatto') }}</h3>
            <div class="form-group">
                <label>{{ $t('portata') }}</label>
                <select v-model="portata" class="form-control">
                    <option value="" disabled selected>-- Seleziona portata --</option>
                    <option value="antipasti">Antipasti</option>
                    <option value="primi">Primi</option>
                    <option value="secondi">Secondi</option>
                    <option value="contorni">Contorni</option>
                    <option value="pizza">Pizza</option>
                    <option value="trancio">Trancio</option>
                    <option value="focaccia">Focaccia</option>
                    <option value="teglia">Teglia</option>
                    <option value="combo">Combo</option>
                    <option value="insalate">Insalate</option>
                    <option value="sushi">Sushi</option>
                    <option value="dolci">Dolci</option>
                    <option value="frutta">Frutta</option>
                    <option value="bevande">Bevande</option>
                    <option value="caffe">Caffè</option>
                    <option value="amari">Amari</option>
                </select>
            </div>
            
            <div class="form-group">
                <label>{{ $t('nome_piatto') }}</label>
                <input type="text" v-model="piatto" class="form-control"/>
            </div>
            
            <div class="form-group">
                <label>{{ $t('prezzo_euro') }}</label>
                <input type="number" v-model="prezzo" class="form-control" />
            </div>
            
            <div class="form-group">
                <label>{{ $t('descrizione') }}</label>
                <textarea v-model="descrizione" class="form-control" rows="3"></textarea>
            </div>
            
            <div class="form-group">
                <label>Foto Piatto</label>
                <div v-if="immagine" style="margin-bottom: 10px; text-align: center;">
                    <img :src="store.path.split('/api')[0] + '/' + immagine" style="max-height: 150px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" />
                </div>
                <input type="file" accept="image/*" capture="environment" @change="onImageSelected" class="form-control" />
            </div>
            
            <div class="action-buttons">
                <button class="btn btn-success btn-block" @click="updateMenu">{{buttonText}}</button>
                <button class="btn btn-danger btn-block" v-if="modifica" @click="eliminaPiatto">{{ $t('elimina_piatto') }}</button>
                <button class="btn btn-secondary btn-block" @click="clearData">{{ $t('deseleziona') }}</button>
                <div class="modal-triggers">
                    <button class="btn btn-outline-dark" @click="showAggiunte = true">{{ $t('aggiunte') }}</button>
                    <button class="btn btn-outline-dark" @click="showSenza = true">{{ $t('senza') }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="cont-mod">

    </div>

</div>
</div>
</template>


<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'About',
  data: function(){

      return {
          piatti:[],
          modifica: '',
          buttonText:'Aggiungi',
          piatto:'',
          prezzo:'',
          descrizione:'',
          immagine:'',
          portata:'',
          prodotti:[],
          add:[],
          minus:[],
          picked:'',
          addPrice:[],
          showAggiunte: false,
          showSenza: false,
          showErrorModal: false,
          errorModalMessage: '',
          store

      }
  },
  methods: {
    getItemLabel(item) {
      if (item === null || item === undefined) return '';
      if (typeof item === 'object') {
        return item.descrizione || item.nome || item.descrizio || item.prodottoId || JSON.stringify(item);
      }
      return item;
    },
    getSortedItems(list) {
      if (!Array.isArray(list)) return [];
      return [...list].sort((a, b) => {
        const labelA = String(this.getItemLabel(a) || '').toLowerCase();
        const labelB = String(this.getItemLabel(b) || '').toLowerCase();
        return labelA.localeCompare(labelB, undefined, { sensitivity: 'base' });
      });
    },
    closeModals() {
        this.showAggiunte = false;
        this.showSenza = false;
        this.showErrorModal = false;
    },
    getParams () {
    },
    updateMenu () {
        const mancano = [];
        if (!this.piatto || !this.piatto.trim()) {
            mancano.push('il nome');
        }
        if (!this.portata || !this.portata.trim()) {
            mancano.push('la portata');
        }

        if (mancano.length > 0) {
            this.errorModalMessage = `Impossibile salvare il piatto: manca ${mancano.join(' e ')}.`;
            this.showErrorModal = true;
            return;
        }

        var price='';
        this.add.forEach(element => {
            const desc = typeof element === 'object' ? element.descrizione : element;
            price = this.prodotti.find(o => o.descrizio === desc || o.nome === desc);
            if(price) {
                console.log(price)

                this.addPrice.push({ nome: price.nome || price.descrizio, prezzo: price['prezzoAggiunta'] ? price['prezzoAggiunta'] : 0 })
            }
        })
        const payload = {
            nome: this.piatto,
            prezzo: this.prezzo,
            descrizione: this.descrizione,
            portata: this.portata,
            addProd: this.add,
            removeProd: this.minus,
            addPrice: this.addPrice
        };

        // Only send immagine if it's a relative path (not a full URL)
        if (this.immagine && !this.immagine.startsWith('http')) {
            payload.immagine = this.immagine;
        }

        this.axios.post(this.store.path + `update`, payload, {
            headers: {
                authorization: `Bearer ${JSON.parse(localStorage.token)}`
            }
        }).then((response) => {
                this.add=[];
                this.minus=[];
             if(response.data){
                console.log('update avvenuto con successo');
                this.displayMenu();
            }else{console.log('Non è stato possibile Aggiornare il menu')}
            })
    },
    eliminaPiatto() {
        const passwordAdmin = prompt("Inserisci la password amministratore per eliminare il piatto:");
        if (passwordAdmin === null) return;

        this.axios.post(this.store.path + `rimuoviPiatto`, { 
            nome: this.piatto, 
            portata: this.portata,
            passwordAdmin: passwordAdmin
        }, {
            headers: {
                authorization: `Bearer ${JSON.parse(localStorage.token)}`
            }
        }).then((response) => {
            if (response.data) {
                console.log('update avvenuto con successo');
                this.displayMenu();
            } else { console.log('Non è stato possibile Aggiornare il menu'); }
        }).catch((error) => {
            console.error("Errore durante l'eliminazione:", error);
            const msg = error.response?.data?.messaggio || "Errore durante l'eliminazione del piatto.";
            alert(msg);
        });
    },
    update (piatto) {
        this.modifica = piatto.nome;
        this.piatto = piatto.nome;
        this.prezzo = piatto.prezzo;
        this.descrizione = piatto.descrizione ? piatto.descrizione : '';
        this.immagine = piatto.immagine ? piatto.immagine : '';
        this.portata = piatto.portata;
        this.add = piatto.addProd ? piatto.addProd : [];
        this.minus = piatto.removeProd ? piatto.removeProd : [];
    },
    isAddChecked(prodotto) {
        return this.add.some(a => {
            const aId = a.prodottoId || a.code;
            const aDesc = a.descrizione || a.descrizio || '';
            return aId === prodotto.code || aDesc === prodotto.descrizio;
        });
    },
    toggleAdd(prodotto) {
        const idx = this.add.findIndex(a => {
            const aId = a.prodottoId || a.code;
            const aDesc = a.descrizione || a.descrizio || '';
            return aId === prodotto.code || aDesc === prodotto.descrizio;
        });
        if (idx >= 0) {
            this.add.splice(idx, 1);
        } else {
            this.add.push({prodottoId: prodotto.code, descrizione: prodotto.descrizio});
        }
    },
    clearData(){
        this.piatto = '';
        this.prezzo ='';
        this.modifica = '';
        this.descrizione = '';
        this.immagine = '';
        this.add = [];
        this.minus = [];
        this.addPrice = [];
    },
    async onImageSelected(event) {
        if (event.target.files.length === 0) return;
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await this.axios.post(this.store.path + 'uploadImg', formData);
            if (response.data.filename) {
                this.immagine = response.data.filename;
                alert('Immagine caricata con successo!');
            }
        } catch (error) {
            console.error(error);
            alert("Errore durante il caricamento dell'immagine.");
        }
    },
    displayMenu() {
        this.axios.post(this.store.path+'displayMenu',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                this.piatti = [];
                console.log('Piatto Aggiunto al menu')
                }else{console.log('Non è stato possibile caricare le sale')}
                response.data.messaggio.forEach(element => {
                    console.log(element.portata)
                  this.piatti.push(element);
                  this.portata = element.portata;
                });
            })
        },
        displayProduct() {
            this.axios.post(this.store.path+'displayProduct',{headers:{
            authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                this.prodotti = [];
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
        home() {
            this.$router.push({ name: "Gestionale"})
        },
  },

  computed : {
      aggiornaButton(){
          let testo = '';
          if(this.modifica){
              testo = this.$t('modifica')
             return testo 
          }else{
              testo = this.$t('aggiungi')
              return testo 
              }
      }
  },
  watch:{
      aggiornaButton:{
          deep:true,
          handler:function(val){
              this.buttonText = val; 
          }
      }
    },
    beforeMount() {
        this.displayMenu();
        this.displayProduct();
    },

}
</script>


<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    height: 100vh;
}
.con-sal {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 15px;
}
.nav-sale{
    flex-basis: 15vh;
    margin-bottom: 20px;
}



.text {
    color: rgb(0, 0, 0);
    padding: 5px;
}

.contMenu {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
}

.edit {
    display: flex;
    flex-direction: column;
    border-style: solid;
    width: 20vw;
    height: 85vh;
    position: relative;
    top:-7vh;
    
}

.modal{
    z-index: 20000;
}


.table{
    width: 80vw;
}
thead {
    position: sticky;
    z-index: 10;
    top: 0;  
}
th,td {
    width: 16vw;
    vertical-align: middle;
    overflow: auto;
}
.pointer {
    cursor: pointer;
}
#style-6 {
    overflow-y: auto;
    height: 500px;
}

#style-6::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-6::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

#style-6::-webkit-scrollbar-thumb
{
  background-color: rgb(19, 20, 26); 
  background-image: -webkit-linear-gradient(45deg,
                                             rgba(255, 255, 255, .2) 25%,
                        transparent 25%,
                        transparent 50%,
                        rgba(255, 255, 255, .2) 50%,
                        rgba(255, 255, 255, .2) 75%,
                        transparent 75%,
                        transparent)
}



.input-mod {
    display: flex;
    justify-content: flex-start;
        align-items: baseline;
}
.cont-tab-select {
    display: flex;
}
.cont-mod {
    display: flex;
    justify-content: space-evenly;
}

.main-content-layout {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
}

.edit-menu {
    flex: 3;
    min-width: 300px;
}

.table-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
    overflow: hidden;
}

.table-wrapper {
    max-height: 70vh;
    overflow-y: auto;
}

.table {
    width: 100%;
    margin-bottom: 0;
    border-collapse: collapse;
}

.table thead th {
    position: sticky;
    top: 0;
    background-color: #343a40;
    color: white;
    z-index: 10;
    padding: 15px;
    white-space: nowrap;
    text-align: left;
}

.table td {
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
    text-align: left;
    vertical-align: middle;
}

.clickable-cell {
    color: #007bff;
    font-weight: bold;
    cursor: pointer;
}

.badge-portata {
    background: #e9ecef;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    text-transform: uppercase;
}

.edit-form-card {
    flex: 1;
    min-width: 300px;
    background: white;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
    align-self: flex-start;
}

.form-title {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.25rem;
    color: #333;
    border-bottom: 2px solid #f8f9fa;
    padding-bottom: 10px;
}

.form-group {
    margin-bottom: 15px;
    text-align: left;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 0.9rem;
}

.form-control {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-sizing: border-box;
}

.action-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
}

.modal-triggers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 10px;
}

.btn-block {
    width: 100%;
}

.input-mod {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-bottom: 5px;
}

@media (max-width: 992px) {
    .main-content-layout {
        flex-direction: column;
    }
    .edit-menu, .edit-form-card {
        width: 100%;
        flex: none;
    }
    .table-wrapper {
        max-height: 50vh;
    }
}
</style>